// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".purchase__testimonials{align-items:center;display:flex;justify-content:center}.purchase__testimonials .link-cta{text-align:left}.purchase__testimonials span.link-cta{cursor:default;position:relative;top:.0625rem}.purchase__testimonials>div{align-items:center;display:flex;justify-content:flex-end;margin-right:var(--spacing)}.purchase__testimonials>div .stars{margin-right:.3125rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
